// import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import states from "./states";
// import app from "@/main";

// app.use(Vuex);

const store =  new Vuex.Store({
  state: states,
  mutations: mutations,
  actions: actions,
  modules: {},
  getters: getters
});

export default store;
